<template>
    <div>
        <div class="detail-card" v-if="Object.keys(product.product_reviews).length > 0">
          <h6>Product Reviews</h6>
          <div class="card" v-for="(review,rdex) in product.product_reviews" :key="rdex">
            <div class="card-left">
              <div class="card-avatar-circle">
                <img v-if="review.product_reviewed_by_image && (review.product_reviewed_by_image != '')" :src="review.product_reviewed_by_image" />
                <img v-else src="/static/assets/images/dummy-image.png" />
              </div>
            </div>
            <div class="card-right"  style="padding-left:6px;">
              <div class="">
                <div>{{review.product_review}}
                  <div class="" style="color: #ffd900;">
                    <span v-for="index in  parseInt(review.product_rate)" class="fa is-filled" :key="index"></span><span v-for="index in (5- parseInt(review.product_rate))" class="fa is-filled" :key="index"></span>
                  </div>
                  {{review.product_reviewed_by}}<br>
                  {{review.product_review_date}}
                </div>
                <!-- { "product_review_id": "47", "product_review": "omara nma, efine wella", "product_rate": "5", "product_reviewed_by": "Ossy Okoye", 
                "product_reviewed_by_image": "default.png", "product_review_date": "2020-04-21 07:22:03pm" } -->
              </div>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <p v-else class="sp-app-default-color">No reviews yet</p>
    </div>
</template>

<style>
 @import url("style.css");
</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
              no_data: true,
            }
        },

        methods: {
            setPage(){
                let self = this;
                localforage.getItem('xvue', function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                        self.product =  value.account.store_sellpoint.store_product;
                    }else{}
                });
           
            },
        },

        components: {},

        created: function(){
            this.setPage();
        }
    }
</script>



// WEBPACK FOOTER //
// ProductReviews.vue?90eeaf94